package com.patronat.top.core.domain.usecase.command.auth

import com.patronat.top.domain.usecase.Command

data class SendCodeToEmailCommand(
    val email: String
) : Command